<template>
<v-card >
  <v-toolbar dense flat dark v-if="(spacesIOwn && spacesIOwn.length > 1)" >
    <v-btn small
      v-for="space in spacesIOwn"
      @click="swapspace(spaceId, space.id)"
      :key="space.id"
      :outlined="parseInt(spaceId)===parseInt(space.id)" >
        {{space.title}}</v-btn>
    <v-spacer/>
    <v-btn icon ><v-icon></v-icon></v-btn>
  </v-toolbar>
  <v-divider/>
  <page
    :title='spaceName'
    :sub-title='activePage.title'
    :with-add='activePage.withAdd'
    :with-reload='true'
    :extension='true'
    :crumbs="crumbs"
    :request='requests.spaces'
    @add='launchAdder'
    @reload='get' >
    <template slot="title" >
      <span v-if='!editTitle' >{{spaceName}}
        <v-btn icon @click='editTitle=true' >
          <v-icon small class='ml-2' >mdi-pen</v-icon>
        </v-btn>
      </span>
      <v-text-field v-else
        class='mt-8'
        append-icon="mdi-pen"
        prepend-icon="mdi-close"
        label="Name of this space"
        v-model='spaceTitle'
        :loading='this.requests.savespaces'
        @keypress.enter="saveTitle(spaceTitle)"
        @blur="saveTitle(spaceTitle)"
        @click:append="saveTitle(spaceTitle)"
        @click:prepend="editTitle=false" />
    </template>
    <template slot='toolbar' >
      <v-spacer></v-spacer>
      <v-btn text
        v-for='tab in tabs'
        :to='`${basePath}/${tab.id}`'
        :key='tab.id' >{{ tab.title }}</v-btn>
    </template>
    <v-card v-if='spaceId === "--"' >
      <v-card-title class='overline' >
        Please choose a Space
      </v-card-title>
      <v-card-text>
        <v-row >
          <v-col v-for='space in spacesIOwn' :key='space.id' >
            <v-btn outlined block
              :to='`/settings/spaces/${space.id}/${page}`'
              :key='space.id' >{{ space.title }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-tabs-items v-else class='mt-6' v-model='activeTab' >
      <v-tab-item v-for='tab in tabs' :key='tab.title' >
        <component
          v-if='tab.component && spaceId'
          :is="tab.component"
          :touch='touch'
          v-bind='tab.attrs' >
        </component>
      </v-tab-item>
    </v-tabs-items>
  </page>
</v-card>
</template>
<script>
import Page from '@/components/layouts/Page.vue'
// import SpaceFeedPage from './SpaceFeedPage.vue'
import SpaceSettings from './SpaceSettings.vue'
import TeamSettings from './TeamSettings.vue'
import LocationListPage from './LocationListPage.vue'
import AppointmentTypesPage from './AppointmentTypesPage.vue'
// import OperatingHoursPage from './OperatingHoursPage'
import Vue from 'vue'

import { mapGetters } from 'vuex'
// import RuleSettings from './RuleSettings'
// import ProductSettings from './ProductSettings'

// import LocationEdit from './LocationEdit'
// import OperatingHours from './OperatingHours'

const TAB_INDEX = {
  'settings': 0,
  'team': 1,
  'locations': 2,
  'appointment-types': 3,
  // 'operating-hours': 4,
  'feed': 4,
}

export default {
  name: 'Spaces',
  props: {
    spaceId: { required: true },
    page: { type: String, required: false }
  },
  components: {Page},
  data () {
    return {
      activeTab: 0,
      touch: 0,
      editTitle: false,
      spaceTitle: '',
      requests: {
        spaces: {
          resource: 'ag.spaces',
          loading: false,
          status: 0,
          result: {}
        },
        savespaces: {
          resource: 'ag.spaces',
        },
        settings: {
          resource: 'ag.spaces',
          result: {}
        }
      }
    }
  },
  methods: {
    get () {
      if (this.spaceId === '--') { return null }
      this.requests.spaces.resourceId = this.spaceId
      this.$request('get', this.requests.spaces)
    },
    swapspace (fromSpace, toSpace) {
      if (fromSpace === toSpace) { return null }

      let path = this.$route.path.replace(fromSpace, toSpace)
      this.$router.push({path})
    },
    launchAdder () {
      if (this.activePage && this.activePage.id) {
        if (this.activePage.id === 'appointment-types') {
          this.launchQuickCreateAppointmentType(this.spaceId, null, 'Add a new appointment type')
        }
        if (this.activePage.id === 'locations') {
          this.launchNewLocationWizard(this.spaceId)
        }
      }
    },
    saveTitle (title) {
      if (this.spaceId) {
        this.requests.savespaces.data = {title}
        this.requests.savespaces.resourceId = this.spaceId
        this.$request('save', this.requests.savespaces)
      }
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        this.get()
      }
    },
    spaceName () {
      this.spaceTitle = this.spaceName
    },
    savingRequestStatus () {
      if (this.savingRequestStatus === 200) {
        Vue.set(this.requests.spaces, 'title', this.spaceTitle)
        this.editTitle = false
      }
    },
    page: {
      immediate: true,
      handler () {
        if (this.page in TAB_INDEX) {
          this.activeTab = TAB_INDEX[this.page]
        } else {
          this.activeTab = 0
          this.page = TAB_INDEX.settings
        }
        this.touch++
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['spaces', 'spacesIOwn']),
    space () {
      return this.requests.spaces.result
    },
    spaceName () {
      return this.getObjectPath(this.space, 'title')
    },
    savingRequestStatus () {
      return this.requests.savespaces.status
    },
    basePath () {
      return `/settings/spaces/${this.spaceId}`
    },
    activePage () {
      if (this.activeTab) {
        let page = this.tabs[this.activeTab]
        if  (!page) { page = this.tabs[0] }
        return page
      }
      return this.tabs[0]
    },
    tabs () {
      if (!this.space) { return [] }

      return [
        {
          id: 'settings',
          title: 'Settings',
          component: SpaceSettings,
          attrs: {
            spaceId: this.spaceId,
            id: this.getObjectPath(this.space, 'settings.id')
          }
        },
        {
          id: 'team',
          title: 'Team',
          component: TeamSettings,
          attrs: {
            spaceId: this.space.id,
            value: this.space.members,
            withAdd: true
          }
        },
        {
          id: 'locations',
          title: 'Locations',
          component: LocationListPage,
          withAdd: true,
          attrs: {
            spaceId: this.space.id,
            value: this.space.addresses
          }
        },
        {
          id: 'appointment-types',
          title: 'Appointment Types',
          component: AppointmentTypesPage,
          withAdd: false,
          attrs: {
            spaceId: this.space.id,
            appointmentTypes: this.space.products
          }
        }
        // {
        //   id: 'feed',
        //   title: 'Feed',
        //   component: SpaceFeedPage,
        //   attrs: {
        //     spaceId: this.spaceId
        //   }
        // }
        // {
        //   id: 'operating-hours',
        //   title: 'Operating hours',
        //   component: OperatingHoursPage,
        //   attrs: {
        //     value: this.space.hours
        //   }
        // }
        // {
        //   title: 'Automation',
        //   component: RuleSettings
        // }
      ]
    },
    crumbs () {
      let crumbs = [
        {text: 'Home', to: '/'},
        {text: 'Spaces', to: '/settings/spaces', 'exact': true }
      ]
      if (this.space && this.space.id) {
        let item = { text: this.space.title, to: this.basePath, 'exact': true }
        crumbs.push(item)
      }
      if (this.page) {
        let index = TAB_INDEX[this.page]
        if (this.tabs && this.tabs.length >= index) {
          let config = this.tabs[index]
          crumbs.push({text: config.title})
        }
      }
      return crumbs
    }
  }
}
</script>
